/**
 * Defines the polling intervals (in milliseconds) for various API endpoints.
 *
 * Naming convention:
 * - The interface name should reflect the API it applies to.
 * - The property names should clearly indicate the endpoint they correspond to.
 */
interface PollingInterval {
  geometry: GeometryApiPollingInterval;
  idmm: IdmmApiPollingInterval;
  megTemplate: MegTemplateApiPollingInterval;
  tmm: TmmApiPollingInterval;
  qa: QAApiPollingInterval;
}

/**
 * Applies to API: avp-avengers-geometry-service-api
 *
 * Used in views: GeometryManagerView
 */
interface GeometryApiPollingInterval {
  // getGroupedRepresentations: number; // for grouped representation in AssemblyManager; not used yet
  getRepresentations: number; // for representations in StructureView
}

/**
 * Applies to API: avp-avengers-idmm-service-api
 *
 * Used in views: GeometryManagerView, IdManagerView, TmmEditorView, TmmView
 */
interface IdmmApiPollingInterval {
  getIdmmInfo: number;
  getIdmmUpdate: number;
}

/**
 * Applies to API: avp-avengers-megtemplate-service-api
 *
 * Used in views: MegTemplateView
 */
interface MegTemplateApiPollingInterval {
  getTree: number;
  getNodeData: number;
}

/**
 * Applies to API: avp-avengers-tmm-service-api
 *
 * Used in views: GeometryManagerView, TargetManagerView, TmmEditorView, TmmView
 */
interface TmmApiPollingInterval {
  getTargetInfo: number;
  getTmmUpdate: number;
}

interface QAApiPollingInterval {
  getMegPrStringInfo: number;
}

export const pollingInterval: PollingInterval = {
  geometry: {
    getRepresentations: 5_000,
  },
  idmm: {
    getIdmmInfo: 20_000,
    getIdmmUpdate: 20_000,
  },
  megTemplate: {
    getTree: 20_000,
    getNodeData: 20_000,
  },
  tmm: {
    getTargetInfo: 20_000,
    getTmmUpdate: 20_000,
  },
  qa: {
    getMegPrStringInfo: 5_000,
  },
};
